import styled from "styled-components";
import { SolutionSwitcherIcon } from "app/components/sidebar3/primary-side-bar/styledComponents";
import { PlainTooltip, PixelPlaceholderLoader } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";

const LoaderWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 10px;
`;

export const getPlainTooltip = () => (
    <PlainTooltip
        placement="right"
        tooltipContent={translate("settings.solution_switcher.tooltip")}
    >
        <div>
            <SolutionSwitcherIcon
                iconName="solution-switcher-v2"
                type="flat"
            />
        </div>
    </PlainTooltip>
);

export const loader = (
    <LoaderWrapper>
        {Array(4)
            .fill(null)
            .map((_, index) => (
                <PixelPlaceholderLoader
                    key={index}
                    width="220px"
                    height="27px"
                />
            ))}
    </LoaderWrapper>
);
